/* eslint-disable import/no-unresolved */
import React from 'react';
import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import { OnChangePlugin } from '@lexical/react/LexicalOnChangePlugin';
import { HistoryPlugin } from '@lexical/react/LexicalHistoryPlugin';
import LexicalErrorBoundary from '@lexical/react/LexicalErrorBoundary';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import 'rubriq/styles/editor.scss';
import ToolbarPlugin from './plugins/ToolbarPlugin';
var RichTextEditor = function RichTextEditor(_ref) {
  var placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    initialState = _ref.initialState;
  var initialConfig = {
    namespace: 'CurieRichTextEditor',
    theme: {
      paragraph: 'editor-paragraph p-0',
      placeholder: 'editor-placeholder',
      text: {
        bold: 'fw-bold',
        italic: 'fst-italic',
        underline: 'text-decoration-underline'
      }
    },
    nodes: [],
    onError: function onError(error) {
      throw error;
    },
    editorState: initialState || null
  };
  var handleChange = function handleChange(editorState) {
    onChange(JSON.stringify(editorState));
  };
  return /*#__PURE__*/React.createElement(LexicalComposer, {
    initialConfig: initialConfig
  }, /*#__PURE__*/React.createElement("div", {
    className: "editor-container border rounded d-flex flex-column h-100 w-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "border-bottom"
  }, /*#__PURE__*/React.createElement(ToolbarPlugin, null)), /*#__PURE__*/React.createElement("div", {
    className: "position-relative",
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "editor-inner position-absolute",
    style: {
      inset: 0
    }
  }, /*#__PURE__*/React.createElement(RichTextPlugin, {
    contentEditable: /*#__PURE__*/React.createElement(ContentEditable, {
      className: "editor-input mh-100",
      role: "textbox"
    }),
    placeholder: placeholder ? /*#__PURE__*/React.createElement("div", {
      className: "editor-placeholder"
    }, placeholder) : null,
    ErrorBoundary: LexicalErrorBoundary
  }), /*#__PURE__*/React.createElement(OnChangePlugin, {
    onChange: handleChange
  }), /*#__PURE__*/React.createElement(HistoryPlugin, null)))));
};
export default RichTextEditor;